<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('disciplinaryCondition.disciplinarySubType') }}
        </label>
        <select v-model="model.dis_sub_type_id" class="form-control"
          :class="{ 'is-invalid': errors.has('dis_sub_type_id') }">
          <option value="">{{ $t('select') }}</option>
          <option v-for="(sub, index) in disciplinarySubTypes" :key="index" :value="sub.dis_sub_type_id">
            {{ sub.dis_sub_type_en + '|' + sub.dis_sub_type_kh }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('dis_sub_type_id')">
          {{ errors.first('dis_sub_type_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">{{ $t('disciplinaryCondition.numberOfDiscipline') }}
        </label>
        <input ref="number_of_discipline" v-model.number="model.number_of_discipline" type="number"
          class="form-control kh-font" :class="{ 'is-invalid': errors.has('number_of_discipline') }" />
        <div class="invalid-feedback" v-if="errors.has('number_of_discipline')">
          {{ errors.first('number_of_discipline') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('disciplinaryCondition.disciplinaryActivity') }}
        </label>
        <select v-model="model.dis_activity_id" class="form-control"
          :class="{ 'is-invalid': errors.has('dis_activity_id') }">
          <option value="">{{ $t('select') }}</option>
          <option v-for="(sub, index) in disciplinaryActivities" :key="index" :value="sub.dis_activity_id">
            {{ sub.dis_activity_en + '|' + sub.dis_activity_kh }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('dis_activity_id')">
          {{ errors.first('dis_activity_id') }}
        </div>
      </div>
      <div class="form-group" v-show="model.dis_activity_id == 10">
        <label class="control-label required">{{ $t('disciplinaryCondition.penaltyUnit') }}
        </label>
        <input v-model.number="model.penalty_unit" type="number" class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('penalty_unit') }" />
        <div class="invalid-feedback" v-if="errors.has('penalty_unit')">
          {{ errors.first('penalty_unit') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinaryCondition.remarks') }}
        </label>
        <textarea v-model="model.remarks" rows="3" class="form-control"
          :class="{ 'is-invalid': errors.has('remarks') }"></textarea>
        <div class="invalid-feedback" v-if="errors.has('remarks')">
          {{ errors.first('remarks') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="update"
          v-if="editing == true">
          {{ $t('update') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'disciplinary-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        number_of_discipline: '',
        remarks: '',
        dis_sub_type_id: '',
        dis_activity_id: '',
        penalty_unit: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      loadingPreData: false
    }
  },
  mounted() {
    this.$refs.number_of_discipline.focus()
  },
  computed: {
    ...mapState('disciplinaryCondition', [
      'disciplinarySubTypes',
      'disciplinaryActivities'
    ])
  },
  async created() {
    this.loadingPreData = true
    await Promise.all([
      this.fetchDisciplinarySubType(),
      this.fetchDisciplinaryActivity()
    ]).then(() => {
      this.loadingPreData = false
      this.setEdit()
    })
  },
  methods: {
    ...mapActions('disciplinaryCondition', [
      'fetchDisciplinarySubType',
      'fetchDisciplinaryActivity'
    ]),
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'disciplinary-condition' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryCondition/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.number_of_discipline.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryCondition/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'disciplinary-condition' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.number_of_discipline.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.number_of_discipline = ''
      this.model.dis_sub_type_en = ''
      this.model.dis_sub_type_id = ''
      this.model.penalty_unit = ''
      this.model.dis_activity_id = ''
      this.model.remarks = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
